<!--代理商tree加强版,将输入框的文本替换为传递过来的参数:treeValue-->
<template>
  <div class="search-item">
    <span v-if="isShowLabel" class="item-label">代理商：</span>
    <span v-if="isHigh" class="item-label">上级代理商：</span>
    <span v-if="isLow" class="item-label">下级代理商：</span>
    <el-popover popper-class="agent-popover" placement="bottom-start" height="300" ref="choseAgentPopover" trigger="click"
      @show="showAgentDepartmentPopover" @hide="hideAgentDepartmentPopover" :visible-arrow="false">
      <div class="c-popover-tab-pane scrollbar-wrapper">
        <el-row :gutter="20">
          <el-col :span="19">
            <el-input class="keyword-search" :placeholder="searchPlaceholder" v-model="filterAgentTextClass" clearable>
            </el-input>
          </el-col>
          <el-col :span="3">
            <el-button type="primary" @click="searchTreeData">搜索</el-button>
          </el-col>
        </el-row>
        <vueEasyTree v-if="isShowTree" :data="agentTreeData" :props="defaultProps" height="200px" show-checkbox
          check-on-click-node node-key="value" ref="agentClassTree" :filter-node-method="filterAgentNode"
          :default-checked-keys="selectAgent" :auto-expand-parent="false" @check="treeCheck">
        </vueEasyTree>
      </div>
    </el-popover>
    <!-- <el-form :model="agentForm" :rules="rules" ref="agentForm" >
        <el-form-item prop="lstAgentId" label-width="120">
          <el-input
            class="selectClass"
            :placeholder="inputPlaceholder"
            readonly
            v-model="agentForm.lstAgentId"
            v-popover:choseAgentPopover
          >
            <span class="el-input__suffix" slot="suffix">
              <span class="el-input__suffix-inner">
                <i
                  class="el-select__caret el-input__icon el-icon-arrow-up"
                  :class="{ 'is-reverse': showAgentDropDown }"
                ></i>
              </span>
            </span>
          </el-input>
        </el-form-item>
      </el-form> -->
    <el-input class="my-input" :class="[showErrorTips ? 'selectClass error' : 'selectClass']" :placeholder="treeValue"
      readonly v-model="agentForm.lstAgentId" v-popover:choseAgentPopover @click="toggleAgentDropdown">
      <span class="el-input__suffix" slot="suffix">
        <span class="el-input__suffix-inner">
          <i class="el-select__caret el-input__icon el-icon-arrow-down" :class="{ 'is-reverse': showAgentDropDown }"></i>
        </span>
      </span>
    </el-input>
    <p v-if="showErrorTips || showError" class="error-tips">请选择代理商</p>
  </div>
</template>
  
<script>
import { getDeptTreeInfo } from "@/api/basicApi";
import { CRM_CAMPUS_TREE } from "@/util/keys";
import vueEasyTree from "@wchbrad/vue-easy-tree"
import "@wchbrad/vue-easy-tree/src/assets/index.scss"
const debounce = (function () {
  let timer = 0;
  return function (func, delay) {
    clearTimeout(timer);
    timer = setTimeout(func, delay);
  };
})();
export default {
  name: "CampusTree",
  data() {
    var checkAgentId = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请选择代理商"));
      } else {
        callback();
      }
    };
    return {
      defaultProps: {
        children: "children",
        label: function (data) {
          return data["title"];
        }
      },
      selectAgent: [],
      selectAgentStr: "",
      filterAgentTextClass: "",
      agentTreeData: [],
      isShowTree: true,
      showAgentDropDown: false,
      agentForm: {
        lstAgentId: ""
      },
      radios: [],
      rules: {
        lstAgentId: [{ validator: checkAgentId }]
      },
      showErrorTips: false
    };
  },
  props: {// 获取父组件传来的值
    showError: {
      type: Boolean,
      default: false
    },
    isShowLabel: {// 是否显示标题“代理商”
      type: Boolean,
      default: false
    },
    isHigh: {// 是否显示标题“上级代理商”
      type: Boolean,
      default: false
    },
    isLow: {// 是否显示标题“下级代理商”
      type: Boolean,
      default: false
    },
    treeValue: {
      type: String, // 根据你的需求设置正确的类型
      default: "请选择代理商ID/代理商名称" // 如果有需要可以设置默认值
    },
    inputPlaceholder: {
      type: String,
      default: "请选择代理商ID/代理商名称"
    },
    searchPlaceholder: {
      type: String,
      default: "输入代理商ID/代理商名查找"
    },
    isSingleChoice: {
      type: Boolean,
      default: false
    }
  },
  components:{
		vueEasyTree,
	},
  mounted() {
    this.getTreeData();
  },
  methods: {
    toggleAgentDropdown() {
      this.showAgentDropDown = !this.showAgentDropDown;
    },
    // 点击搜索
    searchTreeData() {
      let val = this.filterAgentTextClass;
      if (this.showAgentDropDown) {
        this.isShowTree = false;
        debounce(() => {
          this.isShowTree = true;
          this.$nextTick(() => {
            this.$refs.agentClassTree.filter(val);
          });
        }, 300);
        if (val != "") {
          this.$set(this.agentTreeData[0], "disabled", true);
        } else {
          this.isExpand = false;
          this.$set(this.agentTreeData[0], "disabled", false);
        }
      }
    },
    async getTreeData() {
      let CampusTree = JSON.parse(
        sessionStorage.getItem(CRM_CAMPUS_TREE) || "[]"
      );
      if (CampusTree <= 0) {
        CampusTree = await getDeptTreeInfo();
        CampusTree = CampusTree.code === 0 ? CampusTree.data : [];
        sessionStorage.setItem(CRM_CAMPUS_TREE, JSON.stringify(CampusTree));
      }
      const that = this;
      function traverse(val) {
        for (let item of val) {
          item.title = `${that.breakUpCode(item.value)}-${item.title}`;
          if (item.children) {
            traverse(item.children);
          }
        }
      }
      traverse(CampusTree);
      let tree = [
        {
          title: "全选",
          children: CampusTree,
          key: "whole10000",
          value: "whole10000"
        }
      ];
      this.agentTreeData = tree;
    },
    breakUpCode(val) {
      return val.split("_")[1];
    },
    showAgentDepartmentPopover() {
      this.showAgentDropDown = true;
    },
    // 代理商名称
    hideAgentDepartmentPopover() {
      this.selectAgent = [];
      this.agentForm.lstAgentId = "";
      this.showAgentDropDown = false;
      let selectArr = this.$refs.agentClassTree.getCheckedKeys();
      let selectNodeArr = this.$refs.agentClassTree.getCheckedNodes();
      let selectPeopleName = [];
      if (selectArr.length > 0) {
        let selectPeopleArr = selectArr;
        selectNodeArr.map(item => {
          if (item.key != "whole10000") {
            selectPeopleName.push(item["title"]);
          }
        });
        let newSelectPeopleArr = selectPeopleArr.filter(item => {
          if (item) {
            return item;
          }
        });
        let selectAgentStr = selectPeopleName.join(",");
        this.selectAgent = newSelectPeopleArr;
        this.agentForm.lstAgentId = selectAgentStr;
      } else {
        this.selectAgent = [];
        this.agentForm.lstAgentId = "";
      }
      let lastArr = [];
      this.selectAgent = this.selectAgent.map((item, index) => {
        if (item && item.split("_")[1] - 0 > 0) {
          lastArr.push(item.split("_")[1] - 0);
        }
      });
      // this.$refs['agentForm'].clearValidate();
      this.showErrorTips = false;
      this.$emit("selectedAgentDepartment", lastArr);// 触发自定义事件selectedAgentDepartment，并将lastArr作为参数传递
      // console.log("自定义事件", this.treeValue)
    },
    filterAgentNode(value, data) {
      if (!value) {
        return true;
      }
      let trueValue = data.value.toString();
      if (data.value.indexOf("_") > -1) {
        trueValue = data.value.split("_")[1];
      }
      return (
        data.title.toString().indexOf(value) !== -1 ||
        trueValue.indexOf(value) !== -1
      );
    },
    clearSearch() {
      this.agentForm.lstAgentId = "";
      this.selectAgent = [];
      this.filterAgentTextClass = "";
      this.showErrorTips = false;
      this.$refs.agentClassTree.setCheckedKeys([]);
      let length = this.$refs.agentClassTree.$children.length;
      for (let i = 0; i < length; i++) {
        if (this.$refs.agentClassTree.$children[i] && this.$refs.agentClassTree.$children[i].node) {
          this.$refs.agentClassTree.$children[i].node.parent.childNodes[i].expanded = false;
        }
      }
      // this.$refs['agentForm'].resetFields();
      // this.$refs['agentForm'].clearValidate();
    },
    treeCheck(node, list) {
      console.log(node, list);
      if (this.isSingleChoice) {
        //单选实现
        let checkedVal = [node.value];
        if (node.children && node.children.length) {
          checkedVal = [];
        }
        this.$refs.agentClassTree.setCheckedKeys(checkedVal);
      }
    },
    handleBucketClick(row) {
      console.log(row);
      this.radios = [];
      this.radios.push(row.key);
      console.log(this.radios);
    },
    //保证必选！
    checkForm() {
      // let formResult = false;
      // this.$refs['agentForm'].validate((valid) => {
      //   if (valid) {
      //     formResult = true;
      //   } else {
      //     formResult = false;
      //   }
      // });
      if (this.agentForm.lstAgentId) {
        this.showErrorTips = false;
      } else {
        this.showErrorTips = true;
      }
      return this.agentForm.lstAgentId != "" ? true : false;
    }
  }
};
</script>
  
<style lang="scss">
.search-item {
  position: relative;
  display: flex;
  margin-bottom: 25px;
  width: 100%;

  .item-label {
    display: inline-block;
    width: 38%;
    text-align: right;
    margin-top: 10px;

    // padding-right: 12px;
    &:before {
      content: "*";
      color: #f56c6c;
      margin-right: 4px;
    }
  }

  .selectClass {
    margin-left: 10px;

    // width: 403px;
    &.error {
      border-color: #f56c6c;
    }
  }
}

.keyword-search {
  margin-bottom: 10px;
}

.agent-popover {
  width: 380px;
}

.error-tips {
  position: absolute;
  top: 43px;
  left: 120px;
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
}

.my-input {
  .el-input__inner::placeholder {
    color: #606266;
    text-align: center;
  }

  /* 谷歌 */
  .el-input__inner::-webkit-input-placeholder {
    color: #606266;
    text-align: center;
  }

  /* 火狐 */
  .el-input__inner:-moz-placeholder {
    color: #606266;
    text-align: center;
  }

  /*ie*/
  .el-input__inner:-ms-input-placeholder {
    color: #606266;
    text-align: center;
  }
}
</style>
  